import { ButtonGroupField } from 'lib/iterable-hook-form/FormField';
import { FormField } from 'ui/formField';
import { GroupButton } from 'ui/buttonGroup';
import { useFormState } from 'react-hook-form';
import { useStartNodeContext } from '../../StartNodeEditor.context';
import { SEND_ON_DAYS_OPTIONS } from './Scheduler.constants';
import { ErrorText } from './SchedulerForm.styled';
import { SchedulerFormStateValues } from './Scheduler.types';

export const SkipDaysOfWeek = () => {
  const { isReadOnly } = useStartNodeContext();
  const { errors } = useFormState<SchedulerFormStateValues>();
  const { skipDaysOfWeek: skipDaysOfWeekError } = errors;

  return (
    <FormField labelText="Don’t add users on…">
      <ButtonGroupField allowUnselect name="skipDaysOfWeek" allowMultipleSelection>
        {SEND_ON_DAYS_OPTIONS.map(({ id, label }) => (
          <GroupButton key={id} id={`${id}`} isDisabled={isReadOnly} isReadOnly={isReadOnly}>
            {label}
          </GroupButton>
        ))}
      </ButtonGroupField>
      {skipDaysOfWeekError?.message && <ErrorText>{skipDaysOfWeekError.message}</ErrorText>}
    </FormField>
  );
};
